/**
 * Excepcion base para aplicaciones PJN.
 *
 * Todas nuestras excepciones deben extender de esta
 
 * @export
 * @abstract
 * @class PjnException
 * @extends {Error}
 */
export default class PjnException extends Error {
}
//# sourceMappingURL=PjnException.js.map